export const isPasswordValid = (value: string) => {
  return validatePasswordConditionSeparatly(value).allConditions;
};

export const validatePasswordConditionSeparatly = (value: string) => {
  const lowercase = /[a-z]/.test(value);
  const number = /\d/.test(value);
  const longEnough = value.length >= 12 && value.length <= 72;
  const uppercase = /[A-Z]/.test(value);
  const special = /[^\dA-Za-z]/.test(value);

  const allConditions = lowercase && number && longEnough && uppercase && special;
  const anyCondition = lowercase || number || longEnough || uppercase || special;

  return {
    allConditions,
    anyCondition,
    lowercase,
    number,
    longEnough,
    uppercase,
    special,
  };
};
